function handlePressCard({ selectedId, setSelectedIds }) {
    setSelectedIds?.((prev) => {
        let prevIds = new Set(prev)
        // if (prevIds.has(selectedId)) {
        //     prevIds.delete(selectedId)
        // } else {
        prevIds.add(selectedId)
        // }
        return Array.from(prevIds)
    })
}

function cardItemPrecision({ precision, cardId, responseGlobal }) {
    const responsesItems = responseGlobal?.responseItems
    const cardPrecision = responsesItems?.find((response) => response?.responseValue === cardId)
    return cardPrecision?.precisionAnswer ?? precision
}

function handleSetResponseGlobal({ response, selectedCards, setResponseGlobal, surveyId }) {
    const newCards = selectedCards?.map((cardId) => ({
        precisionAnswer: "",
        responseTypeId: 1,
        responseValue: cardId
    }))

    setResponseGlobal((prev) => {
        if (prev?.[surveyId]?.surveyId > 0) {
            const prevResponseItems = prev?.[surveyId]?.responseItems
            const filteredCards = newCards?.map((cardItem) => {
                const existedCardAlready = prevResponseItems?.find(
                    (item) => item.responseValue === cardItem.responseValue
                )

                if (existedCardAlready) {
                    return existedCardAlready
                }

                return cardItem
            })

            return {
                ...prev,
                [surveyId]: {
                    ...prev?.[surveyId],
                    responseItems: filteredCards
                }
            }
        } else {
            console.log({ newCards })
            return {
                ...prev,
                [surveyId]: {
                    ...response,
                    responseItems: [newCards]
                }
            }
        }
    })
}

function handleSetCardPrecision({ choosed, response, precisionAnswer, setResponseGlobal, surveyId }) {
    if (choosed) {
        setResponseGlobal((prev) => {
            if (prev?.[surveyId]?.surveyId > 0) {
                const prevResponseItems = prev?.[surveyId]?.responseItems
                const newCards = prevResponseItems?.map((cardItem) => {
                    if (cardItem?.responseValue === choosed) {
                        return {
                            precisionAnswer,
                            responseTypeId: 1,
                            responseValue: choosed
                        }
                    }
                    return cardItem
                })

                const firstContent = {
                    precisionAnswer,
                    responseTypeId: 1,
                    responseValue: choosed
                }

                const values = prevResponseItems?.length > 0 ? newCards : [firstContent]

                return {
                    ...prev,
                    [surveyId]: {
                        ...prev?.[surveyId],
                        responseItems: values
                    }
                }
            } else {
                const newCards = {
                    precisionAnswer,
                    responseTypeId: 1,
                    responseValue: choosed
                }

                return {
                    ...prev,
                    [surveyId]: {
                        ...response,
                        responseItems: [newCards]
                    }
                }
            }
        })
    }
}

function handlePreselectCardFromSavedResponse({ responseGlobal, surveyId, setSelectedCards }) {
    const allCardIds = responseGlobal?.[surveyId]?.responseItems?.map((item) => item.responseValue)
    setSelectedCards(allCardIds ?? [])
}

export {
    handlePreselectCardFromSavedResponse,
    handleSetCardPrecision,
    handleSetResponseGlobal,
    cardItemPrecision,
    handlePressCard
}
